import React from "react";
import "./Home.css";

function Batteries() {
  return (
    <div className="home-section-container">
      <div className="home-content-split">
        <div className="home-text-content">
          <div className="title-text-cont">
            <h1>Power System</h1>
            <p className="home-subtitle">
              <img className="brandImg" src="/goalZero.png" />
              <br />
              Yeti 3000x
              <hr />
            </p>
            <p className="home-subtitle">
              <img className="brandImg" src="/eg4.png" />
              <br />
              EV4 LL 400ah Lithium Battery
            </p>
          </div>
        </div>

        <div className="home-image-content">
          <iframe src="https://drive.google.com/file/d/1Yz43S0aCcRf8fyXvFJzXz90s082ClUWl/preview"></iframe>
        </div>
      </div>

      <div className="outdoorsy-container" style={{ textAlign: "left" }}>
        <p className="tealText">
          The van contains two batteries, the small “dumb” battery that powers
          the AC and recharges the larger “smart” battery (GoalZero). This small
          battery is charged when the van is running, through solar panels, and
          if the van is plugged into shore power. The large GoalZero powers
          everything else in the van (refrigerator, lights, water heater, etc.).
          It gets charged by the small battery.
        </p>
        <p className="tealText">
          Battery management is very important when living in a van! Chappie
          contains a lot of battery power, but it’s still possible to drain his
          batteries too quickly and end up with no power. Don’t be afraid to use
          all of his systems, but have a conservation mindset when using
          power-heavy components (the AC, induction stove, and water heater).
        </p>

        <p className="tealText">
          <strong>Use these apps to track the battery power:</strong>
        </p>
        <div className="app-download-section">
          <div className="app-column">
            <img
              src="/goalzeroApp.png"
              alt="Goal Zero App"
              className="app-logo"
            />
            <div className="store-links">
              <a
                href="https://apps.apple.com/us/app/goal-zero-yeti/id1369567573"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/apple.svg"
                  alt="Download on App Store"
                  className="store-icon"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.goalzero.YetiApp&hl=en_US&pli=1"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/google.png"
                  alt="Download on Google Play"
                  className="store-icon"
                />
              </a>
            </div>
          </div>

          <div className="app-column">
            <img
              src="/victronapp.png"
              alt="VictronConnect App"
              className="app-logo"
            />
            <div className="store-links">
              <a
                href="https://itunes.apple.com/us/app/victron-connect/id943840744?mt=8"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/apple.svg"
                  alt="Download on App Store"
                  className="store-icon"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.victronenergy.victronconnect"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/google.png"
                  alt="Download on Google Play"
                  className="store-icon"
                />
              </a>
            </div>
          </div>
        </div>

        <p className="tealText">
          <strong>Some battery conserving tips:</strong>
        </p>
        <ul className="tealText">
          <li>
            Don’t sleep with the AC on. Crank it before sleeping to cool the van
            down, but use the battery powered fan at night.
          </li>
          <li>
            Use the induction burners to prepare quick meals. No slow-cooked
            stews on this adventure!
          </li>
          <li>
            Keep the water heater unplugged when driving or if not using. Plug
            it in to heat the water in the tank during the day when the sun is
            still out and charging the battery. Water will stay warm in the hot
            water heater for a while, but it uses a lot of power to initially
            heat up water in the tank.
          </li>
        </ul>

        <p className="tealText">
          Channel your inner camping guru :) Chappie has some great features to
          make your adventure more comfortable, but be mindful of his limited
          battery power.
        </p>
      </div>

      <div className="movCont">
        <img src="/batteries.jpg" className="home-image" />
      </div>
    </div>
  );
}

export default Batteries;
